import { css } from 'styled-components'
import { rgba, stripUnit } from 'polished'

import * as spacing from 'styles/spacing'
import { greyDark } from 'styles/colors'
import { fontSizes } from 'styles/typography'

export default css`
  .tooltip {
    background-color: ${rgba(greyDark, 0.9)} !important;
    font-size: ${fontSizes.tiny} !important;
    padding: ${spacing.small} ${stripUnit(spacing.small) * 1.5 + 'px'} !important;
    border-radius: 5px !important;
    transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out !important;
    max-width: 260px !important;
    text-align: center !important;

    &.large {
      font-size: ${fontSizes.small} !important;
    }

    &.place-right {
      margin-left: 13px !important;
    }

    &.show {
      opacity: 1 !important;
    }

    &:before {
      display: none !important;
    }

    &:after {
      border-top-color: ${rgba(greyDark, 0.9)} !important;
      border-top-width: 5px !important;
      border-left: 5px solid transparent !important;
      border-right: 5px solid transparent !important;
      bottom: -5px !important;
      margin-left: -5px !important;
    }

    &.place-right:after {
      border-top-color: transparent !important;
      border-right-color: ${rgba(greyDark, 0.9)} !important;
      margin-top: -5px !important;
      left: -5px !important;
    }
  }

  .zEWidget-launcher {
    margin-right: 12px !important;
    margin-bottom: 12px !important;
  }
`
